import type { valita } from './valita'

export const jsonSchemeParse = <O extends any>(json: string, scheme: valita.Type<O>): O | null => {
  try {
    const raw = JSON.parse(json)
    return scheme.parse(raw, { mode: 'strip' })
  } catch {
    return null
  }
}
